// import {
//   Button,
//   Col,
//   DatePicker,
//   Form,
//   Input,
//   message,
//   Modal,
//   Row,
//   Select,
//   Table,
//   Upload,
// } from "antd";
// import axios from "axios";
// import moment from "moment";
// import { useCallback, useState } from "react";
// import { MdFileDownload, MdUpload } from "react-icons/md";
// import * as XLSX from "xlsx";
// import { API } from "../../../Config";
// import File from "../../Delivery/excel/PURCHASE_EXCELL_FILE.xlsx";
// import { useSelector } from "react-redux";

// const SalesForm = (props) => {
//   const [form] = Form.useForm();
//   const [loading, setLoading] = useState(false);
//   const [uploading, setUploading] = useState(false);
//   const dateFormat = "DD/MM/YYYY";
//   const selectedPurchase = props?.selectedPurchase || "";
//   const Auth = useSelector((state) => state.Auth.user);

//   const getInitialDataSource = () => {
//     if (props?.selectedPurchase?.saleDetails?.length > 0) {
//       return props?.selectedPurchase?.saleDetails?.map((item) => ({
//         ...item,
//         key: item.id || Date.now() + Math.random(),
//         discount: item.discount || 0,
//       }));
//     } else {
//       return [
//         {
//           key: Date.now(),
//           name: "",
//           price: 1,
//           description: "",
//           discount: 0,
//           quantity: 1,
//         },
//       ];
//     }
//   };

//   const [dataSource, setDataSource] = useState(getInitialDataSource());

//   const handleFinish = async (values) => {
//     try {
//       setLoading(true);
//       const invalidRow = dataSource.find(
//         (item) => !item.quantity || Number(item.quantity) <= 0
//       );
//       if (invalidRow) {
//         message.error("Please enter valid quantity for all products.");
//         setLoading(false);
//         return;
//       }

//       const payload = {
//         description: values.description,
//         agentId: values.agentId,
//         userid: Number(Auth?.id),
//         payment_date: values.purchase_date,
//         items: dataSource.map((item) => ({
//           name: item?.name?.toString(),
//           price: Number(item.price),
//           discount: Number(item.discount) || 0,
//           quantity: Number(item.quantity),
//           description: item.description || "",
//           key: Number(item.id),
//         })),
//       };

//       const response = selectedPurchase?.id
//         ? await axios.put(
//             `${API.BASR_URL}${API.SALE}/${selectedPurchase.id}`,
//             payload
//           )
//         : await axios.post(`${API.BASR_URL}${API.SALE}`, payload);
//       if (response?.status) {
//         message.success(
//           `Sale ${selectedPurchase?.id ? "updated" : "added"}  successfully`
//         );
// resetFormAndData();
// props?.onClose();
// props?.relaod();
//       }
//       setLoading(false);
//     } catch (error) {
//       message.error(`Oops. Something went wrong ${error}`);
//       console.error("Update amount field error:", error);
//       setLoading(false);
//     }
//   };

//   const renderSummary = () => {
//     const totalQuantity = dataSource?.reduce(
//       (acc, item) => acc + Number(item.quantity || 0),
//       0
//     );
//     const totalPrice = dataSource?.reduce(
//       (acc, item) =>
//         acc +
//         (Number(item.price) * Number(item.quantity) -
//           Number(item.discount || 0)),
//       0
//     );
//     return (
//       <Table.Summary.Row style={{ height: 50 }}>
//         <Table.Summary.Cell index={0} />
//         <Table.Summary.Cell index={1}>
//           <Button onClick={handleAddProduct}>Add New</Button>
//         </Table.Summary.Cell>
//         <Table.Summary.Cell index={2} />
//         <Table.Summary.Cell index={3}>
//           <strong>Total Quantity</strong>
//         </Table.Summary.Cell>
//         <Table.Summary.Cell index={4}>
//           <strong>{totalQuantity || 0}</strong>
//         </Table.Summary.Cell>
//         <Table.Summary.Cell index={5}>
//           <strong>Total Price</strong>
//         </Table.Summary.Cell>
//         <Table.Summary.Cell index={5}>
//           <strong>{Number(totalPrice || 0).toFixed(2)}</strong>
//         </Table.Summary.Cell>
//       </Table.Summary.Row>
//     );
//   };
//   const handleChangeValueSet = useCallback((value, key, field) => {
//     setDataSource((prev) => {
//       const newDataSource = prev.map((val) => {
//         if (val.key === key) {
//           const updates = { [field]: value };

//           // Validation: discount should not exceed price
//           if (field === "discount") {
//             const numericPrice = Number(val.price || 0);
//             const numericDiscount = Number(value || 0);
//             if (numericDiscount > numericPrice) {
//               Modal.warning({
//                 title: "Invalid Discount",
//                 content: "Discount cannot be greater than the price.",
//               });
//               return val; // don't update
//             }
//           }

//           return { ...val, ...updates };
//         }
//         return val;
//       });

//       return newDataSource;
//     });
//   }, []);

//   const handleAddProduct = useCallback(() => {
//     setDataSource((prev) => [
//       ...prev,
//       {
//         key: Date.now(), // Unique key
//         name: "",
//         price: 0,
//         discount: 0,
//         quantity: 1,
//       },
//     ]);
//   }, []);

//   const handleExcelUpload = (file) => {
//     setUploading(true);
//     const reader = new FileReader();

//     reader.onload = (e) => {
//       try {
//         const data = new Uint8Array(e.target.result);
//         const workbook = XLSX.read(data, { type: "array" });
//         const sheetName = workbook.SheetNames[0];
//         const worksheet = workbook.Sheets[sheetName];
//         const jsonData = XLSX.utils.sheet_to_json(worksheet);

//         // Transform Excel data to match table structure
//         const transformedData = jsonData.map((row, index) => ({
//           key: Date.now() + index,
//           name: row.Name || row.name || "",
//           description: row.Description || row.description || "",
//           price: Number(row.Price || row.price || 0),
//           discount: Number(row.Discount || row.discount || 0), // Default to 0 if not provided
//           quantity: Number(row.Quantity || row.quantity || 1),
//         }));

//         // Validate the data
//         const isValidData = transformedData.every(
//           (item) =>
//             item.name &&
//             item.description &&
//             !isNaN(item.price) &&
//             !isNaN(item.discount) &&
//             !isNaN(item.quantity) &&
//             item.price >= 0 &&
//             item.discount >= 0 &&
//             item.quantity > 0
//         );

//         if (isValidData) {
//           setDataSource(transformedData);
//           message.success(
//             `Successfully imported ${transformedData.length} products from Excel`
//           );
//         } else {
//           message.error(
//             "Invalid data format in Excel file. Please check the sample format."
//           );
//         }
//       } catch (error) {
//         message.error(
//           "Error reading Excel file. Please ensure it's a valid Excel file."
//         );
//         console.error("Excel upload error:", error);
//       } finally {
//         setUploading(false);
//       }
//     };

//     reader.readAsArrayBuffer(file);
//     return false; // Prevent default upload behavior
//   };

//   const handleRemoveProduct = useCallback((key) => {
//     setDataSource((prev) => prev.filter((item) => item.key !== key));
//   }, []);

//   const columns = [
//     {
//       title: "Sl",
//       dataIndex: "slno",
//       key: "slno",
//       width: 30,
//       align: "center",
//       fixed: "left",
//       render: (_, __, index) => index + 1,
//     },
//     {
//       title: "Name",
//       dataIndex: "name",
//       key: "name",
//       render: (text, record) => (
//         <Input.TextArea
//           autoSize={{ minRows: 1, maxRows: 6 }}
//           bordered={false}
//           value={record.name}
//           onChange={(e) =>
//             handleChangeValueSet(e.target.value, record.key, "name")
//           }
//         />
//       ),
//     },
//     {
//       title: "Price",
//       dataIndex: "price",
//       key: "price",
//       render: (_, record) => (
//         <Input
//           type="number"
//           min={0}
//           bordered={false}
//           value={record.price}
//           onKeyDown={(e) => {
//             if (e.key === "e" || e.key === "E") {
//               e.preventDefault();
//             }
//           }}
//           onChange={(e) =>
//             handleChangeValueSet(e.target.value, record.key, "price")
//           }
//         />
//       ),
//     },
//     {
//       title: "Discount",
//       dataIndex: "discount",
//       key: "discount",
//       render: (_, record) => (
//         <Input
//           type="number"
//           min={0}
//           bordered={false}
//           value={record.discount}
//           onKeyDown={(e) => {
//             if (e.key === "e" || e.key === "E") {
//               e.preventDefault();
//             }
//           }}
//           onChange={(e) =>
//             handleChangeValueSet(e.target.value, record.key, "discount")
//           }
//         />
//       ),
//     },
//     {
//       title: "Quantity",
//       dataIndex: "quantity",
//       key: "quantity",
//       render: (_, record) => (
//         <Input
//           type="number"
//           min={0}
//           bordered={false}
//           value={record.quantity}
//           onKeyDown={(e) => {
//             if (e.key === "e" || e.key === "E") {
//               e.preventDefault();
//             }
//           }}
//           onChange={(e) =>
//             handleChangeValueSet(e.target.value, record.key, "quantity")
//           }
//         />
//       ),
//     },
//     {
//       title: "Description",
//       dataIndex: "description",
//       key: "description",
//       render: (_, record) => (
//         <Input
//           bordered={false}
//           value={record.description}
//           onKeyDown={(e) => {
//             if (e.key === "e" || e.key === "E") {
//               e.preventDefault();
//             }
//           }}
//           onChange={(e) =>
//             handleChangeValueSet(e.target.value, record.key, "description")
//           }
//         />
//       ),
//     },
//     {
//       title: "Total",
//       dataIndex: "total",
//       key: "total",
//       render: (_, record) => {
//         const itemTotal =
//           Number(record.price) * Number(record.quantity) -
//           Number(record.discount || 0);
//         return <span>{Number(itemTotal).toFixed(2)}</span>;
//       },
//     },
//     {
//       title: "Action",
//       dataIndex: "action",
//       key: "action",
//       render: (_, record) => (
//         <Button
//           danger
//           type="link"
//           onClick={() => handleRemoveProduct(record.key)}
//         >
//           Remove
//         </Button>
//       ),
//     },
//   ];
//   const handleDownload = () => {
//     const link = document.createElement("a");
//     link.href = File;
//     link.download = "PURCHASE_EXCELL_FILE.xlsx";
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };
//   const resetFormAndData = () => {
//     form.resetFields();
//     setDataSource([]);
//   };

//   return (
//     <Modal
//       title={selectedPurchase?.id ? "Update Sales" : "Add Sales"}
//       open={props.visible}
//       onCancel={props.onClose}
//       footer={false}
//       width={900}
//     >
//       <Form
//         form={form}
//         onFinish={handleFinish}
//         initialValues={{
//           agentId: selectedPurchase?.agentDetails?.account_no,
//           purchase_date: selectedPurchase?.payment_date
//             ? moment(selectedPurchase.payment_date)
//             : null,
//           description: selectedPurchase?.description,
//         }}
//       >
//         <Row>
//           <Col md={12}>
//             <Form.Item
//               label="Agent Name"
//               name="agentId"
//               rules={[{ required: true }]}
//               labelCol={{ span: 7 }}
//             >
//               <Select
//                 size="medium"
//                 showSearch
//                 allowClear
//                 filterOption={(input, option) => {
//                   const searchText = input.toLowerCase();
//                   const optionText = option.children.toString().toLowerCase();
//                   return optionText.includes(searchText);
//                 }}
//               >
//                 {props.accounts?.map((item) => (
//                   <Select.Option key={item.account_no} value={item.account_no}>
//                     {item.account_no} - {item.account_name}
//                   </Select.Option>
//                 ))}
//               </Select>
//             </Form.Item>
//             <Form.Item
//               label="Sale Date"
//               name="purchase_date"
//               rules={[{ required: true }]}
//               labelCol={{ span: 7 }}
//             >
//               <DatePicker
//                 size="medium"
//                 format={dateFormat}
//                 style={{ width: "100%" }}
//               />
//             </Form.Item>
//           </Col>
//           <Col md={12}>
//             <Form.Item
//               label="Description"
//               name="description"
//               labelCol={{ span: 7 }}
//             >
//               <Input.TextArea rows={1} size="medium" />
//             </Form.Item>
//             <Form.Item
//               label="Upload Excel"
//               labelCol={{ span: 7 }}
//               className="g-3"
//             >
//               <Upload
//                 beforeUpload={handleExcelUpload}
//                 accept=".xlsx,.xls"
//                 showUploadList={false}
//                 loading={uploading}
//               >
//                 <Button loading={uploading} icon={<MdUpload />}>
//                   {uploading ? "Uploading..." : "Upload Excel"}
//                 </Button>
//               </Upload>
//               &nbsp;&nbsp;&nbsp;
//               <Button onClick={handleDownload} icon={<MdFileDownload />}>
//                 Sample File
//               </Button>
//             </Form.Item>
//           </Col>
//           <Col md={8} />
//         </Row>
//       </Form>
//       <Table
//         columns={columns}
//         dataSource={dataSource}
//         pagination={false}
//         summary={renderSummary}
//       />
//       <Row justify="end" gutter={[16, 0]} style={{ marginTop: 16 }}>
//         <Col>
//           <Button
//             onClick={() => {
//               resetFormAndData();
//               props.onClose();
//             }}
//           >
//             Cancel
//           </Button>
//         </Col>
//         <Col>
//           <Button
//             type="primary"
//             onClick={() => form.submit()}
//             loading={loading}
//           >
//             {selectedPurchase?.id ? "Update" : "Save"}
//           </Button>
//         </Col>
//       </Row>
//     </Modal>
//   );
// };

// export default SalesForm;

import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Table,
  Upload,
  Checkbox,
  Space,
} from "antd";
import axios from "axios";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { MdFileDownload, MdUpload } from "react-icons/md";
import * as XLSX from "xlsx";
import { API } from "../../../Config";
import File from "../../Delivery/excel/PURCHASE_EXCELL_FILE.xlsx";
import { useSelector } from "react-redux";

const SalesForm = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [isPaymentEnabled, setIsPaymentEnabled] = useState(true); // Default to true
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const dateFormat = "DD/MM/YYYY";
  const selectedPurchase = props?.selectedPurchase || {};
  const Auth = useSelector((state) => state.Auth.user);

  const getInitialDataSource = () => {
    if (props?.selectedPurchase?.saleDetails?.length > 0) {
      return props?.selectedPurchase?.saleDetails?.map((item) => ({
        ...item,
        key: item.id || Date.now() + Math.random(),
        discount: item.discount || 0,
      }));
    } else {
      return [
        {
          key: Date.now(),
          name: "",
          price: 1,
          description: "",
          discount: 0,
          quantity: 1,
        },
      ];
    }
  };

  const [dataSource, setDataSource] = useState(getInitialDataSource());

  const totalPrice = dataSource.reduce(
    (acc, item) =>
      acc +
      (Number(item.price) * Number(item.quantity) - Number(item.discount || 0)),
    0
  );

  // Set default payment amount when enabling payment or totalPrice changes
  useEffect(() => {
    if (isPaymentEnabled) {
      form.setFieldsValue({ payment_amount: totalPrice });
    } else {
      form.setFieldsValue({ payment_amount: 0 });
    }
  }, [isPaymentEnabled, totalPrice, form]);

  const handleFinish = async (values) => {
    try {
      setLoading(true);
      const invalidRow = dataSource.find(
        (item) => !item.quantity || Number(item.quantity) <= 0
      );
      if (invalidRow) {
        message.error("Please enter valid quantity for all products.");
        setLoading(false);
        return;
      }

      const total_charge = totalPrice;
      const paymentAmount = Number(values.payment_amount) || 0;

      if (isPaymentEnabled && paymentAmount > total_charge) {
        message.error("Payment amount cannot exceed total price.");
        setLoading(false);
        return;
      }

      const selectedAccount = props?.accounts?.find(
        (acc) => acc?.account_no === values?.payment_account_no
      );

      const payload = {
        description: values.description,
        agentId: values.agentId,
        userid: Number(Auth?.id),
        payment_date: values.purchase_date,
        total_charge,
        isPaymentEnabled,
        created_from: "web",
        payment: isPaymentEnabled
          ? {
              method: values.payment_method,
              amount: paymentAmount,
              account_no:
                values.payment_method === "bank"
                  ? values.payment_account_no
                  : null,
              account_name: selectedAccount?.account_name || "",
              description: values.payment_description || "",
            }
          : null,
        items: dataSource.map((item) => ({
          name: item?.name?.toString(),
          price: Number(item.price),
          discount: Number(item.discount) || 0,
          quantity: Number(item.quantity),
          description: item.description || "",
          key: Number(item?.id),
        })),
      };

      const response = selectedPurchase?.id
        ? await axios.put(
            `${API.BASR_URL}${API.SALE}/${selectedPurchase.id}`,
            payload
          )
        : await axios.post(`${API.BASR_URL}${API.SALE_CREATE}`, payload);
      if (response?.status) {
        message.success(
          `Sale ${selectedPurchase?.id ? "updated" : "added"} successfully`
        );
        resetFormAndData();
        props?.onClose();
        props?.relaod();
      }
      setLoading(false);
    } catch (error) {
      message.error(`Oops. Something went wrong ${error}`);
      console.error("Update amount field error:", error);
      setLoading(false);
    }
  };

  const renderSummary = () => {
    const totalQuantity = dataSource?.reduce(
      (acc, item) => acc + Number(item.quantity || 0),
      0
    );
    const paidAmount = Number(form.getFieldValue("payment_amount") || 0);
    const outstanding = totalPrice - paidAmount;

    return (
      <Table.Summary.Row style={{ height: 50 }}>
        <Table.Summary.Cell index={0} />
        <Table.Summary.Cell index={1}>
          <Button onClick={handleAddProduct}>Add New</Button>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={2} />
        <Table.Summary.Cell index={3}>
          <strong>Total Quantity</strong>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={4}>
          <strong>{totalQuantity || 0}</strong>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={5}>
          <strong>Total Price</strong>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={6}>
          <strong>{Number(totalPrice || 0).toFixed(2)}</strong>
        </Table.Summary.Cell>
        {/* <Table.Summary.Cell index={7}>
          <strong>Outstanding</strong>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={8}>
          <strong>{Number(outstanding || 0).toFixed(2)}</strong>
        </Table.Summary.Cell> */}
      </Table.Summary.Row>
    );
  };

  const handleChangeValueSet = useCallback((value, key, field) => {
    setDataSource((prev) => {
      const newDataSource = prev.map((val) => {
        if (val.key === key) {
          const updates = { [field]: value };

          // Validation: discount should not exceed price
          if (field === "discount") {
            const numericPrice = Number(val.price || 0);
            const numericDiscount = Number(value || 0);
            if (numericDiscount > numericPrice) {
              Modal.warning({
                title: "Invalid Discount",
                content: "Discount cannot be greater than the price.",
              });
              return val; // don't update
            }
          }

          return { ...val, ...updates };
        }
        return val;
      });

      return newDataSource;
    });
  }, []);

  const handleAddProduct = useCallback(() => {
    setDataSource((prev) => [
      ...prev,
      {
        key: Date.now(),
        name: "",
        price: 0,
        discount: 0,
        quantity: 1,
      },
    ]);
  }, []);

  const handleExcelUpload = (file) => {
    setUploading(true);
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        // Transform Excel data to match table structure
        const transformedData = jsonData.map((row, index) => ({
          key: Date.now() + index,
          name: row.Name || row.name || "",
          description: row.Description || row.description || "",
          price: Number(row.Price || row.price || 0),
          discount: Number(row.Discount || row.discount || 0),
          quantity: Number(row.Quantity || row.quantity || 1),
        }));

        // Validate the data
        const isValidData = transformedData.every(
          (item) =>
            item.name &&
            item.description &&
            !isNaN(item.price) &&
            !isNaN(item.discount) &&
            !isNaN(item.quantity) &&
            item.price >= 0 &&
            item.discount >= 0 &&
            item.quantity > 0
        );

        if (isValidData) {
          setDataSource(transformedData);
          message.success(
            `Successfully imported ${transformedData.length} products from Excel`
          );
        } else {
          message.error(
            "Invalid data format in Excel file. Please check the sample format."
          );
        }
      } catch (error) {
        message.error(
          "Error reading Excel file. Please ensure it's a valid Excel file."
        );
        console.error("Excel upload error:", error);
      } finally {
        setUploading(false);
      }
    };

    reader.readAsArrayBuffer(file);
    return false; // Prevent default upload behavior
  };

  const handleRemoveProduct = useCallback((key) => {
    setDataSource((prev) => prev.filter((item) => item.key !== key));
  }, []);

  const columns = [
    {
      title: "Sl",
      dataIndex: "slno",
      key: "slno",
      width: 50,
      align: "center",
      fixed: "left",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
      render: (text, record) => (
        <Input.TextArea
          autoSize={{ minRows: 1, maxRows: 6 }}
          bordered={false}
          value={record.name}
          onChange={(e) =>
            handleChangeValueSet(e.target.value, record.key, "name")
          }
        />
      ),
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      width: 120,
      render: (_, record) => (
        <Input
          type="number"
          min={0}
          bordered={false}
          value={record.price}
          onKeyDown={(e) => {
            if (e.key === "e" || e.key === "E") {
              e.preventDefault();
            }
          }}
          onChange={(e) =>
            handleChangeValueSet(e.target.value, record.key, "price")
          }
        />
      ),
    },
    {
      title: "Discount",
      dataIndex: "discount",
      key: "discount",
      width: 120,
      render: (_, record) => (
        <Input
          type="number"
          min={0}
          bordered={false}
          value={record.discount}
          onKeyDown={(e) => {
            if (e.key === "e" || e.key === "E") {
              e.preventDefault();
            }
          }}
          onChange={(e) =>
            handleChangeValueSet(e.target.value, record.key, "discount")
          }
        />
      ),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      width: 120,
      render: (_, record) => (
        <Input
          type="number"
          min={0}
          bordered={false}
          value={record.quantity}
          onKeyDown={(e) => {
            if (e.key === "e" || e.key === "E") {
              e.preventDefault();
            }
          }}
          onChange={(e) =>
            handleChangeValueSet(e.target.value, record.key, "quantity")
          }
        />
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 200,
      render: (_, record) => (
        <Input
          bordered={false}
          value={record.description}
          onKeyDown={(e) => {
            if (e.key === "e" || e.key === "E") {
              e.preventDefault();
            }
          }}
          onChange={(e) =>
            handleChangeValueSet(e.target.value, record.key, "description")
          }
        />
      ),
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      width: 100,
      render: (_, record) => {
        const itemTotal =
          Number(record.price) * Number(record.quantity) -
          Number(record.discount || 0);
        return <span>{Number(itemTotal).toFixed(2)}</span>;
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: 100,
      render: (_, record) => (
        <Button
          danger
          type="link"
          onClick={() => handleRemoveProduct(record.key)}
        >
          Remove
        </Button>
      ),
    },
  ];

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = File;
    link.download = "PURCHASE_EXCELL_FILE.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const resetFormAndData = () => {
    form.resetFields();
    setDataSource([]);
    setIsPaymentEnabled(true); // Reset to true
    setPaymentMethod("cash");
  };

  return (
    <Modal
      title={selectedPurchase?.id ? "Update Sales" : "Add Sales"}
      open={props.visible}
      onCancel={props.onClose}
      footer={false}
      width={900}
      style={{ top: 20 }}
    >
      <Form
        form={form}
        onFinish={handleFinish}
        initialValues={{
          agentId: selectedPurchase?.agentDetails?.account_no,
          purchase_date: selectedPurchase?.payment_date
            ? moment(selectedPurchase.payment_date)
            : null,
          description: selectedPurchase?.description,
          payment_method: selectedPurchase?.payment?.method || "cash",
          payment_amount: selectedPurchase?.paid_amount || totalPrice,
          payment_account_no: selectedPurchase?.payment?.account_no,
          payment_description: selectedPurchase?.payment?.description,
        }}
        layout="vertical"
      >
        <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
          <Col md={12}>
            <Form.Item
              label="Agent Name"
              name="agentId"
              rules={[{ required: true, message: "Please select an agent" }]}
            >
              <Select
                size="middle"
                showSearch
                allowClear
                placeholder="Select agent"
                filterOption={(input, option) => {
                  const searchText = input.toLowerCase();
                  const optionText = option.children.toString().toLowerCase();
                  return optionText.includes(searchText);
                }}
              >
                {props.accounts?.map((item) => (
                  <Select.Option key={item.account_no} value={item.account_no}>
                    {item.account_no} - {item.account_name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Sale Date"
              name="purchase_date"
              rules={[{ required: true, message: "Please select a date" }]}
            >
              <DatePicker
                size="middle"
                format={dateFormat}
                style={{ width: "100%" }}
              />
            </Form.Item>
            <Form.Item label="Description" name="description">
              <Input.TextArea
                rows={2}
                size="middle"
                placeholder="Enter description"
              />
            </Form.Item>
            <Form.Item label="Upload Excel">
              <Space>
                <Upload
                  beforeUpload={handleExcelUpload}
                  accept=".xlsx,.xls"
                  showUploadList={false}
                  loading={uploading}
                >
                  <Button loading={uploading} icon={<MdUpload />} size="middle">
                    {uploading ? "Uploading..." : "Upload Excel"}
                  </Button>
                </Upload>
                <Button
                  onClick={handleDownload}
                  icon={<MdFileDownload />}
                  size="middle"
                >
                  Sample File
                </Button>
              </Space>
            </Form.Item>
          </Col>
          <Col md={12}>
            <Form.Item label="Enable Payment" valuePropName="checked">
              <Checkbox
                checked={isPaymentEnabled}
                onChange={(e) => setIsPaymentEnabled(e.target.checked)}
              >
                Record Payment
              </Checkbox>
            </Form.Item>
            {isPaymentEnabled && (
              <Space
                direction="vertical"
                size="middle"
                style={{ width: "100%" }}
              >
                <Form.Item
                  label="Payment Method"
                  name="payment_method"
                  rules={[
                    {
                      required: true,
                      message: "Please select a payment method",
                    },
                  ]}
                >
                  <Select
                    size="middle"
                    onChange={(value) => setPaymentMethod(value)}
                    placeholder="Select payment method"
                  >
                    <Select.Option value="cash">Cash</Select.Option>
                    <Select.Option value="bank">Bank</Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Payment Amount"
                  name="payment_amount"
                  rules={[
                    { required: true, message: "Please enter payment amount" },
                    {
                      validator: (_, value) =>
                        value >= 0
                          ? value <= totalPrice
                            ? Promise.resolve()
                            : Promise.reject(
                                "Payment amount cannot exceed total price"
                              )
                          : Promise.reject("Amount must be non-negative"),
                    },
                  ]}
                >
                  <Input
                    type="number"
                    min={0}
                    max={totalPrice}
                    size="middle"
                    placeholder="Enter amount"
                    onKeyDown={(e) => {
                      if (e.key === "e" || e.key === "E") {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
                {paymentMethod === "bank" && (
                  <Form.Item
                    label="Account No"
                    name="payment_account_no"
                    rules={[
                      { required: true, message: "Please select an account" },
                    ]}
                  >
                    <Select
                      size="middle"
                      showSearch
                      allowClear
                      placeholder="Select account"
                      filterOption={(input, option) => {
                        const searchText = input.toLowerCase();
                        const optionText = option.children
                          .toString()
                          .toLowerCase();
                        return optionText.includes(searchText);
                      }}
                    >
                      {props.accounts?.map((item) => (
                        <Select.Option
                          key={item.account_no}
                          value={item.account_no}
                        >
                          {item.account_no} - {item.account_name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
                <Form.Item
                  label="Payment Description"
                  name="payment_description"
                >
                  <Input.TextArea
                    rows={2}
                    size="middle"
                    placeholder="Enter payment description"
                  />
                </Form.Item>
              </Space>
            )}
          </Col>
        </Row>
      </Form>
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        summary={renderSummary}
        scroll={{ x: 800 }}
      />
      <Row justify="end" gutter={[16, 0]} style={{ marginTop: 16 }}>
        <Col>
          <Button
            onClick={() => {
              resetFormAndData();
              props.onClose();
            }}
            size="middle"
          >
            Cancel
          </Button>
        </Col>
        <Col>
          <Button
            type="primary"
            onClick={() => form.submit()}
            loading={loading}
            size="middle"
          >
            {selectedPurchase?.id ? "Update" : "Save"}
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default SalesForm;
